<template>
  <div class="content">
    <template v-for="block in content">
      <div v-if="block.type == 'file'" class="file" :key="block.id">
        <a :href="block.attrs.src" target="_blank"
          ><img class="arrow down" src="./../assets/icons/arrow.svg" />&nbsp;{{
            block.attrs.caption
          }}</a
        >
      </div>
      <div class="image" :key="block.id" v-if="block.type == 'img'">
        <img :src="block.attrs.src" :alt="block.attrs.caption" />
        <figcaption class="pl" v-html="block.attrs.caption" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    content: Array
  }
};
</script>

<style lang="scss" scoped>
h1,
p {
  margin-bottom: var(--lh);
}
li {
  list-style: none;
  padding-left: calc(2 * var(--lh));
  position: relative;
  &:before {
    content: "–";
    position: absolute;
    top: 0;
    left: 0;
  }
  + h1,
  + p {
    margin-top: var(--lh);
  }
}
.content {
  position: relative;
  width: 100%;
}
.file {
  padding-bottom: var(--lh);
  padding-right: var(--lh);
  padding-left: calc(0.5 * var(--lh));
}
.image {
  // position: absolute;
  // left: calc(100% + 1px + (0.5 * var(--lh)));
  width: 100%;
  padding-bottom: calc(1 * var(--lh));
  cursor: default;
  img {
    width: 100%;
    max-height: 60vh;
    object-fit: contain;
    object-position: top left;
  }
}
</style>
